import type { Podcast } from "@/hooks/usePodcasts";
import type { Episode } from "@/hooks/useEpisodes";

/**
 * Determines if a podcast is still being processed (transcribed/indexed).
 *
 * A podcast is "processing" when:
 * - podcast.episodeCount > 0 (backend knows about episodes)
 * - But episodes.length === 0 (no episodes returned yet - still indexing)
 */
export function isPodcastProcessing(
  podcast: Podcast | null,
  episodes: Episode[],
): boolean {
  if (!podcast) return false;
  const expectedCount = podcast.episodeCount ?? 0;
  return expectedCount > 0 && episodes.length === 0;
}
